import { AgGridReact } from 'ag-grid-react';
import { RefObject } from 'react';
import {
  Tabs,
  CHECK,
  VIRTUAL_CARD,
  CREDIT_CARD,
  CHECK_CREDIT_CARD,
  AP_CHECK_LANDING_PAGE,
  VIRTUAL_CARD_LANDING_PAGE,
  CHECK_LANDING_PAGE
} from 'common/constants';
import { ComposedTableDataType } from 'components/ComposedTable/types';

export const retrievePaymentMethod = <TData extends ComposedTableDataType>(
  gridRef: RefObject<AgGridReact<TData>>,
  selectedTab: string,
  paymentMethod: string | undefined,
  landingPageFlag: boolean | undefined
): string => {
  const checkValue = landingPageFlag ? AP_CHECK_LANDING_PAGE : CHECK;
  const checkTableValue = landingPageFlag ? CHECK_LANDING_PAGE : CHECK;
  const virtualCardValue = landingPageFlag
    ? VIRTUAL_CARD_LANDING_PAGE
    : VIRTUAL_CARD;
  if (selectedTab === Tabs.ToBePaid) {
    if (paymentMethod === checkValue) {
      return CHECK;
    }
    if (paymentMethod === virtualCardValue) {
      return CREDIT_CARD;
    }
    const tableData = gridRef.current?.api?.getDataAsCsv();
    if (
      tableData?.includes(`,"${checkTableValue}",`) &&
      tableData?.includes(`,"${virtualCardValue}",`)
    )
      return CHECK_CREDIT_CARD;
    if (tableData?.includes(`,"${checkTableValue}",`)) return CHECK;
    return CREDIT_CARD;
  }
  if (selectedTab === Tabs.NeedsAuthorization) {
    if (paymentMethod === checkValue) return CHECK;
    return CREDIT_CARD;
  }
  if (selectedTab === Tabs.ReconcileCreditCards) return CREDIT_CARD;
  return CHECK;
};
